export default __webpack_public_path__ + "assets/images/ilustracao-vendas-sucesso04eb1bfb573777d38acece614defeedf.png";